import { BaseResidentParameterDto } from '../../_models/base-resident-parameter-dto';

export class ViolationHistoryParameterDto extends BaseResidentParameterDto {
  violationId: string;

  constructor(customerId?: string, communityId?: number) {
    super(customerId, communityId);
  }

  override getQueryString(): string {
    return `?customerId=${this.customerId}&communityId=${this.communityId}&violationId=${this.violationId}&clearCache=${this.clearCache}`;
  }
}
